/*

Sainapse® incorporates patented, and “patent pending”, technology.

© 2017 - 2024 Sainapse Inc. and its licensors. All rights reserved worldwide.

Sainapse Inc. and its licensors own all rights in this work, including but not limited to the source code, algorithms, text, 
flowcharts and images herein, which are protected by copyright laws in applicable jurisdictions. Any use of this work is permissible 
only with an express written license or authorization from Sainapse Inc., and only to the extent and for the purpose permitted. 
Unauthorized copying, editing, reproduction, redistribution, modification, creation of derivative works, translation, adaptation, 
customization, decompilation, reverse engineering, disassembling or hacking of this work or any part thereof, including but not limited to the source code, 
header files and libraries of the software, via any medium is strictly prohibited.

Open Source Software that is provided as part of Sainapse® is subject to and governed solely by the terms and conditions of the applicable open source license agreements, 
and their respective terms, conditions, restrictions and obligations, a copy of which will be made available to you upon request.

Proprietary and Confidential. Sainapse® and associated documentation is the property of Sainapse Inc. and considered confidential information. 
No part of it may be disclosed without the express written consent of Sainapse Inc.Please note that any infringement or violation will invite legal action, 
both civil and criminal, as appropriate, without any further notice.

*/
import React, { Component, Fragment } from 'react';

import { withStyles } from '@material-ui/core/styles'

import { Paper, Popover, IconButton, CardActions, Tooltip, Avatar, Dialog, Typography, Slide, CircularProgress, List, ListItem, ListItemText, ListSubheader } from '@material-ui/core'

import { AttachFile, Visibility, Warning, Clear } from '@material-ui/icons'

import viewer_config from '../../../Config/viewer_config'
import Viewer from '../../Viewer'

import Action from '../../../../../../fluid/Actions/ActionFactory'
import ErrorMessage from '../../../../../Common/ErrorMessage'
//const clone = require('rfdc')()
import clone from "lodash/cloneDeep";
const styles = theme => ({

})

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});

class Attachment extends Component {
    state = {
        open_att_viewer : false,
        wv_url : null,
        wv_url_error : null,
        drl_result : null,
        drl_result_error : null,
        loading_viewer : false,
        data_ready : false,
        open_attach_options : false,
        attach_anchor_el : null
    }

    attach = React.createRef()

    loadViewer = () => {
        this.setState({
            ...this.state,
            loading_viewer : true
        }, () => {
            Action("http_request", {
                url: "/sainapse/world_view_server/" + this.props.server_name,
                method: "get",
                data: {},
            }).then(res => {
                let wv_server = res.data.result.name
                Action("http_request", {
                    url: this.props.drl_url + "/drl/file",
                    method: "get",
                    params: {
                      wv_server: wv_server,
                      file_type: this.getFileInfo()[1],
                      file_id: this.props.file_id,
                    },
                    data: {},
                }).then(res => {
                    let drl_result = res.data;
                    this.setState({
                        ...this.state,
                        loading_viewer : false,
                        wv_url : wv_server,
                        wv_url_error : null,
                        drl_result : drl_result,
                        drl_result_error : null,
                        data_ready : true
                    })
                }).catch(err => {
                    this.setState({
                        ...this.state,
                        loading_viewer : false,
                        wv_url : wv_server,
                        wv_url_error : null,
                        drl_result : null,
                        drl_result_error : err,
                        data_ready : false
                    })
                })
            }).catch(err => {
                this.setState({
                    ...this.state,
                    loading_viewer : false,
                    wv_url : null,
                    wv_url_error : err,
                    drl_result : null,
                    drl_result_error : null,
                    data_ready : false
                })
            })
        })
    }

    isSupported = () => {
        let viewer_index = viewer_config.findIndex(viewer => viewer.sub_type.includes(this.props.file_type))
        if (viewer_index !== -1) {
            return true
        } else {
            return false
        }
    }

    getFileInfo = () => {
        let file_name = this.props.path
        let file_type = file_name.split('.')[file_name.split('.').length - 1].toLowerCase()
        return [file_name, file_type]
    }

    renderAvatar = () => {
        console.log("Path :", this.props.path)
        if (this.isSupported()) {
            let viewer_index = viewer_config.findIndex(viewer => viewer.sub_type.includes(this.props.file_type))
            return React.createElement(viewer_config[viewer_index].avatar, {disabled : false})
        } else {
            return (
                <Tooltip title = "Unsupported Format">
                    <Avatar style = {{backgroundColor : "#F4D80D"}}>
                        <Warning style = {{color : "#000000"}}/>
                    </Avatar>
                </Tooltip>
            )
        }
    }

    closeAttViewer = () => {
        this.setState({
            ...this.state,
            open_att_viewer : false
        })
    }

    viewDoc = () => {
        this.setState({
            ...this.state,
            open_att_viewer : true
        }, () => this.loadViewer())
    }

    renderAttachmentViewer = () => {
        if (this.state.open_att_viewer) {
            return (
                <Dialog fullScreen open={this.state.open_att_viewer} onClose={this.closeAttViewer} TransitionComponent={Transition}>
                    <Paper square elevation = {3} style = {{width : '100%', display : 'flex', flexDirection : 'row', alignItems : 'center', height : '50px', padding : '10px'}}>
                        {/* <Typography style = {{flexGrow : 1}} variant = 'subtitle2'>{this.getFileInfo()[0]}</Typography> */}
                        <Tooltip title = 'Close'>
                            <IconButton size = 'small' onClick = {this.closeAttViewer}>
                                <Clear fontSize = 'small'/>
                            </IconButton>
                        </Tooltip>
                    </Paper>
                    {this.renderViewer()}
                </Dialog>
            )
        }
    }

    generateConfig = () => {
        let config = viewer_config.find(item => item.type.includes("DATA")).template
        return config
        // if (this.props.highlight) {
        //     // let highlight_param = config.params.find(param => param.key === "highlight")
        //     // highlight_param.value.boolean = true
        //     return config
        // } else {
        //     return config
        // }
    }

    renderViewer = () => {
        var toPX = require("to-px");
        if (!this.state.loading_viewer) {
            if (this.state.data_ready) {
                let record = clone(this.props.record)
                record.iu_record_src_info.iu_content_type.sub_type = this.props.file_type
                record.group = false
                record.iu_record_src_info.iu_record_nav_info.location.position = 1
                record.source_link.path = this.props.path
                record.source_link.src_file_name = this.props.file_name
                return Viewer(
                    {
                        id: this.props.file_name,
                        viewer: "data",
                        config: this.generateConfig(),
                        record: record,
                        edit: false
                    },
                    {
                        width: toPX('100vw'),
                        height: toPX('100vh') - 50,
                        wv_url: this.state.wv_server_url,
                        drl_url: this.props.drl_url,
                        drl_result: this.state.drl_result,
                        file_id: this.props.file_id,
                        location_index: 1,
                        key_terms: [],
                        copy_text: (text) => null,
                        search_string : this.props.search_string ? this.props.search_string : ""
                    }
                );
            } else {
                if (this.state.wv_url_error !== null) {
                    return (
                        <div style = {{width : '100vw', height : 'calc(100vh - 50px)', display : 'flex', flexDirection : 'row', justifyContent : 'center', alignItems : 'center'}}>
                            <ErrorMessage error_message = "Error Retreiving World View Server" err = {this.state.wv_url_error}/>
                        </div>
                    )
                }
    
                if (this.state.drl_result_error !== null) {
                    return (
                        <div style = {{width : '100vw', height : 'calc(100vh - 50px)', display : 'flex', flexDirection : 'row', justifyContent : 'center', alignItems : 'center'}}>
                            <ErrorMessage error_message = "Error Retreiving file from DRL" err = {this.state.drl_result_error}/>
                        </div>
                    )
                }
            }
        } else {
            return (
                <div style = {{width : '100vw', height : 'calc(100vh - 50px)', display : 'flex', flexDirection : 'row', justifyContent : 'center', alignItems : 'center'}}>
                    <CircularProgress/>
                </div>
            )
        }
    }

    renderAttachmentOptions = () => {
        console.log("Attachment options : ", this.props.attach_options)
        return (
            <Popover
                id={"attach-options"}
                open={this.state.open_attach_options}
                anchorEl={this.state.attach_anchor_el}
                onClose={this.closeAttachmentOptions}
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'right',
                }}
                transformOrigin={{
                    vertical: 'top',
                    horizontal: 'right',
                }}
            >
                <div>
                    <List 
                        // subheader = {<ListSubheader>Select the field you want to attach to...</ListSubheader>}
                    >
                        {this.props.attach_options.map(option => {
                            return (
                                <ListItem 
                                    button
                                    onClick = {() => this.setState({...this.state, open_attach_options : false, attach_anchor_el : null}, () => this.props.re_attach_attachment(option, this.props.attachment))}
                                >
                                    <ListItemText primary = {option.field} secondary = {option.helper}/>
                                </ListItem>
                            )
                        })}
                    </List>
                </div>
            </Popover>
        )
    }

    openAttachmentOptions = (event) => {
        this.setState({...this.state, 
            attach_anchor_el: event.currentTarget,
            open_attach_options : true
        })
    }

    closeAttachmentOptions = () => {
        this.setState({...this.state, 
            open_attach_options : false,
            attach_anchor_el : null
        })
    }

    render() {
        return (
            <Fragment>
                {this.state.open_attach_options && this.renderAttachmentOptions()}
                <Paper variant = 'outlined' style = {{
                    width : this.props.width ? this.props.width : '98%',
                    backgroundColor : '#F0F0F0', 
                    padding : 0, 
                    display : 'flex', 
                    flexDirection : 'row', 
                    alignItems : 'center', 
                    margin : '5px',
                    height : this.props.height ? this.props.height : '100%'
                }}>
                    {this.props.show_title && 
                    <div style = {{display : 'flex', flexDirection : 'row', alignItems : 'center', flexGrow : 1, overflow: 'hidden', borderRight : '1px solid rgba(0,0,0,0.12)'}}>
                        <div style = {{padding : '5px'}}>
                            {this.renderAvatar()}
                        </div>
                        <Tooltip title = {this.getFileInfo()[0]}>
                            <div style = {{padding : '5px'}}>
                                <Typography style = {{cursor : 'pointer'}} variant = 'body2' display = 'block' noWrap>{this.props.file_name}</Typography>
                                <Typography style = {{cursor : 'pointer'}} variant = 'caption' color = 'textSecondary'>{this.props.file_type.toUpperCase()}</Typography>
                            </div>
                        </Tooltip>
                    </div>}
                    {this.props.show_view && this.props.server_name && <div style = {{padding : '5px'}}>
                        <Tooltip title = 'View document'>
                            <IconButton style = {{display : 'block'}} size = 'small' color = 'primary' disabled = {!this.isSupported()} onClick = {this.viewDoc}>
                                <Visibility fontSize = 'small'/>
                            </IconButton>
                        </Tooltip>
                    </div>}
                    {this.props.re_attach && <div style = {{padding : '5px', borderLeft : '1px solid rgba(0,0,0,0.12)'}}>
                        <Tooltip title = 'Attach'>
                            <IconButton style = {{display : 'block'}} size = 'small' color = 'primary' onClick = {this.openAttachmentOptions}>
                                <AttachFile fontSize = 'small'/>
                            </IconButton>
                        </Tooltip>
                    </div>}
                </Paper>
                {this.renderAttachmentViewer()}
            </Fragment>
        );
    }
}

export default withStyles(styles)(Attachment);